/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:23
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').controller('PrTrashCtrl', ["$rootScope", "$scope", function ($rootScope, $scope) {


    $scope.restore = function (prView) {
        if (prView) {
            if (prView != -1)// retrieve old value from server
                prView.restoreModel();
            var index = $scope.dd.view.physicalResourcesDeletedView.indexOf(prView);
            if (index != -1) {
                $scope.dd.view.physicalResourcesDeletedView.splice(index, 1);
                $scope.dd.view.physicalResourcesActiveView.push(prView);
                if (prView.hasPlanning)
                    $scope.dd.view.physicalResourcesView.push(prView);
            }


        }

    };
}]);



// WEBPACK FOOTER //
// ./js/controllers/pro/configuration/pr/prTrashCtrl.js